
import React from 'react'
import { Tabs, Pagination, Checkbox, message } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import NoData from '../com/NoData';
import { values } from 'lodash';
const CheckboxGroup = Checkbox.Group;
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class messageCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuList: [
        { label: '系统消息', key: '1' }
      ],
      tabList: [
        { label: '未读', key: '0' },
        { label: '已读', key: '1' },
        { label: '全部', key: '9' }
      ],
      tabValue: '0',
      data: [],
      states: [0],
      page: 1,
      total: 0,
      pageSize: 10,
      checkedList: []
    }
  }
  async componentDidMount() {
    this.getUserInfo();
    this.loadData();
  }

  componentWillUnmount() {

  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }

  loadData = () => {
    const { states, page, pageSize } = this.state;
    let params = {
      states,
      page,
      records:pageSize
    }
    const onLoadData = (res) => {
      if (res.status == 0) {
        this.setState({ data: res.results, total: res.results.length })
      } else {
        this.setState({ data: [], total: 0 })
      }
    }
    WidgetAjax.ajax({ url: path + '/message/list', params, callback: onLoadData });
  }

  onPageChange = () => {

  }

  check = (data) => {
    this.props.history.push({ pathname: '/home/messageCenter/mes_info', data: { type: 'message', data: { ...data, id: data?.item } } })
  }

  onCheckChange = (value) => {
    this.setState({ checkedList: value });
  }

  allChecked = () => {
    const { checkedList, data } = this.state;
    if (checkedList && data && data.length == checkedList.length) {
      this.setState({ checkedList: [] })
    } else {
      let keyList = data.map(item => String(item.id));
      this.setState({ checkedList: keyList });
    }
  }

  signRead = () => {
    const { checkedList } = this.state;
    if (checkedList && checkedList.length > 0) {
      const onReceive = (res) => {
        if (res.status == 0) {
          message.success("标记成功!");
          this.setState({ checkedList: [] })
          this.loadData()
        } else {
          message.error("标记失败!" + res.message);
        }
      }
      WidgetAjax.ajax({ url: path + '/message/receive', params: { ids: checkedList }, callback: onReceive });
    } else {
      message.info("请先选择数据!")
    }
  }

  remove = () => {
    const { checkedList } = this.state;
    if (checkedList && checkedList.length > 0) {
      const onRemove = (res) => {
        if (res.status == 0) {
          message.success("删除成功!");
          this.setState({ checkedList: [] })
          this.loadData()
        } else {
          message.error("删除失败!" + res.message);
        }
      }
      WidgetAjax.ajax({ url: path + '/message/remove', params: { ids: checkedList }, callback: onRemove });
    } else {
      message.info("请先选择数据!")
    }
  }

  tabsChange = async (value) => {

    this.setState({ tabValue: value, checkedList: [] });
    if (value === '9') {
      await this.setState({ states: [0, 1] })
    } else {
      await this.setState({ states: [value] })
    }
    this.loadData()
  }



  render() {
    const { menuList, tabList, tabValue, data, page, total, pageSize, checkedList } = this.state;

    return <div component-data="messageCenter">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200'>
            <div className='head_title'>消息中心</div>
          </div>
        </div>

        <div className='mes_box box_1200' style={{ paddingTop: "104px" }}>
          <div className='mes_menu'>
            <Tabs items={menuList} tabPosition={'right'} />
          </div>
          <div className='mes_content'>
            <div className='menu_head'>
              <div className='menu_tabs'>
                <Tabs items={tabList} activeKey={tabValue} onChange={(value) => this.tabsChange(value)} />
              </div>
            </div>
            <div className='sys_mes_op'>
              <Checkbox onChange={this.allChecked} checked={data && data.length > 0 ? checkedList.length == data.length : false} ></Checkbox>
              {tabValue != '1' ? <div>【<a onClick={() => { this.signRead() }}>标记已读</a>】</div> : null}
              <div onClick={() => { this.remove() }}>【<a>删除</a>】</div>
            </div>
            <div className='menu_list'>
              <CheckboxGroup onChange={this.onCheckChange} value={checkedList}  >
                {
                  data && data.length > 0 ?
                    data.map((item) => {
                      return <div className='mes_item_box'>
                        <Checkbox value={item?.id} key={item.id} />
                        <div className={item?.state == 0 ? 'mes_items' : 'mes_item'}>
                          <img className='mes_logo' src={require("../../img/pinzhunzhun/enterprise/enterprise_icon.png")} />
                          <div className='mes_context'>
                            <div className='mes_title'>{item?.message}</div>
                            <div>{item?.issue_time}</div>
                          </div>
                          <div className='mes_op' onClick={() => { this.check(item) }}>查看</div>
                        </div>

                      </div>
                    })
                    : <NoData />
                }
              </CheckboxGroup>
              <div className="cardtable-pagination">
                <Pagination
                  hideOnSinglePage={true}
                  showQuickJumper
                  defaultCurrent={page}
                  total={total}
                  pageSize={pageSize}
                  pageSizeOptions={[10, 20, 50, 100]}
                  onChange={this.onPageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  }
}

export default messageCenter;